import type { RouteObject } from "react-router-dom"
import AdminBracketPage from "@/components/admin/AdminBracketPage"
import AdminDashboardPage from "@/components/admin/AdminDashboardPage"
import AdminEntryDetailPage from "@/components/admin/AdminEntryDetailPage"
import AdminEntryListPage from "@/components/admin/AdminEntryListPage"
import AdminLoginPage from "@/components/admin/AdminLoginPage"
import AdminTournamentFormPage from "@/components/admin/AdminTournamentFormPage"
import AdminTournamentListPage from "@/components/admin/AdminTournamentListPage"
import AdminLayout from "@/components/layout/AdminLayout"
import BracketPage from "@/components/bracket/BracketPage"
import EntryFeePage from "@/components/entry/EntryFeePage"
import EntryFormPage from "@/components/entry/EntryFormPage"
import EntryLookupPage from "@/components/entry/EntryLookupPage"
import EntryModifyPage from "@/components/entry/EntryModifyPage"
import HomePage from "@/components/home/HomePage"
import TournamentListPage from "@/components/tournament/TournamentListPage"
import TournamentDetailPage from "@/components/tournament/TournamentDetailPage"
import NotFoundPage from "@/components/common/NotFoundPage"
import PublicLayout from "@/components/layout/PublicLayout"

/**
 * 화면 목록은 이 테이블이 전부다.
 * 새 화면을 추가하면 여기에만 연결하면 되고, 어떤 화면이 있는지 한눈에 보인다.
 *
 * `/admin/*` 은 `AdminLayout` 이 세션을 확인하고 없으면 `/login` 으로 보낸다.
 */
const routes: RouteObject[] = [
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: "tournaments", element: <AdminTournamentListPage /> },
      { path: "tournaments/:id", element: <AdminTournamentFormPage /> },
      { path: "entries", element: <AdminEntryListPage /> },
      { path: "entries/:id", element: <AdminEntryDetailPage /> },
      { path: "brackets", element: <AdminBracketPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
  {
    path: "/",
    element: <PublicLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "tournaments", element: <TournamentListPage /> },
      { path: "tournaments/:id", element: <TournamentDetailPage /> },
      { path: "application", element: <EntryFormPage /> },
      { path: "application/lookup", element: <EntryLookupPage /> },
      { path: "application/modify", element: <EntryModifyPage /> },
      { path: "fee", element: <EntryFeePage /> },
      { path: "bracket", element: <BracketPage /> },
      { path: "login", element: <AdminLoginPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]

export { routes }
